__webpack_require__.p = "https://www.mlb.com/apps/player-of-the-game/game/";